import { useState, useEffect } from 'react'

const TIMER_UPDATE_MS = 500

const useDuration = (localStartTime, gameDurationSeconds, gameSecondsOffset) => {
  const [duration, setDuration] = useState(null)

  useEffect(() => {
    if (isNaN(localStartTime) || isNaN(gameDurationSeconds) || isNaN(gameSecondsOffset)) {
      return
    }

    const intervalId = window.setInterval(() => {
      const localOffset = Date.now() - localStartTime
      setDuration((gameDurationSeconds || 0) + gameSecondsOffset + localOffset)
    }, TIMER_UPDATE_MS)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [localStartTime, gameDurationSeconds, gameSecondsOffset])

  if (duration === null) {
    return '...'
  }

  const totalSeconds = Math.floor(duration / 1000)
  const seconds = totalSeconds % 60
  const totalMinutes = Math.floor(totalSeconds / 60)
  const minutes = totalMinutes % 60
  const hours = Math.floor(totalMinutes / 60)

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  }

  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
}

export default useDuration
